import { colors } from "../colors";
import { getDaysInMonth } from "../../utils/general";

// Availability

export const cl_synop_in_oscar = ["==", ["get", "in_oscar"], true];
const cl_synop_not_in_oscar = ["==", ["get", "in_oscar"], false];

const cl_synop_silent = [
  "==",
  ["/", ["get", "nr_received"], ["get", "nr_expected"]],
  0
];

// Timeliness <=15 min dark green
const cl_very_small_timeliness_delay = partBaseline => {
  return [
    "all",
    [">=", ["get", "timeliness"], 0],
    ["<=", ["get", "timeliness"], 900]
  ];
};
// 50min <Timeliness <=100min green
const cl_small_timeliness_delay = partBaseline => {
  return [
    "all",
    [">", ["get", "timeliness"], 900],
    ["<=", ["get", "timeliness"], 1800]
  ];
};
// 100min < Timeliness <= 150min yellow
const cl_moderate_timeliness_delay = partBaseline => {
  return [
    "all",
    [">", ["get", "timeliness"], 1800],
    ["<=", ["get", "timeliness"], 7200]
  ];
};
// 150 min < Timeliness <  300min.  orange
const cl_large_timeliness_delay = partBaseline => {
  return ["all", [">", ["get", "timeliness"], 7200]];
};
//  Timeliness > 300min Red
const cl_very_large_timeliness_delay = partBaseline => {
  return ["all", [">", ["get", "timeliness"], 18600]];
};

const cl_synop_big_issues = partBaseline => {
  return [
    "all",
    [">", ["/", ["get", "nr_received"], partBaseline], 0],
    ["<", ["/", ["get", "nr_received"], partBaseline], 0.3]
  ];
};

const cl_gbon_synop_big_issues = partBaseline => {
  return [
    "all",
    [">", ["/", ["get", "nr_received"], partBaseline], 0],
    ["<", ["/", ["get", "nr_received"], partBaseline], 0.3]
  ];
};

const cl_synop_small_issues = partBaseline => {
  return [
    "all",
    [">=", ["/", ["get", "nr_received"], partBaseline], 0.3],
    ["<", ["/", ["get", "nr_received"], partBaseline], 0.8]
  ];
};

const cl_gbon_synop_small_issues = partBaseline => {
  return [
    "all",
    [">=", ["/", ["get", "nr_received"], partBaseline], 0.3],
    ["<", ["/", ["get", "nr_received"], partBaseline], 0.8]
  ];
};

const cl_synop_normal = partBaseline => {
  return [
    "all",
    [">=", ["/", ["get", "nr_received"], partBaseline], 0.8],
    ["<=", ["/", ["get", "nr_received"], partBaseline], 1]
  ];
};

const cl_gbon_synop_normal = partBaseline => {
  return ["all", [">=", ["/", ["get", "nr_received"], partBaseline], 0.8]];
};

const cl_synop_moreThan100p = partBaseline => {
  return [
    "all",
    [">", partBaseline, 0],
    [">", ["/", ["get", "nr_received"], partBaseline], 1]
  ];
};

const cl_synop_expectedZero = partBaseline => {
  return ["all", ["==", partBaseline, 0], [">", ["get", "nr_received"], 0]];
};

const cl_gbon_synop_expectedZero = partBaseline => {
  return ["all", ["==", partBaseline, 0], [">", ["get", "nr_received"], 0]];
};

export const getStyleSynopAvailability = (baseline, period_type, date) => {
  let valuePeriodType = 6; // for six_hour
  if (period_type === "daily") {
    valuePeriodType = 24;
  } else if (period_type === "monthly") {
    // monthly
    let nbDays = getDaysInMonth(date);
    valuePeriodType = ["*", nbDays, 24];
    // valuePeriodType = ["get", "nr_full_days"];
  }
  const partBaseline =
    baseline === "OSCAR" ? ["get", "nr_expected"] : valuePeriodType;
  if (baseline === "GBON") {
    return [
      "case",
      cl_synop_silent,
      colors.map.synop.availability[4],
      cl_synop_big_issues(partBaseline),
      colors.map.synop.availability[3],
      cl_synop_small_issues(partBaseline),
      colors.map.synop.availability[2],
      cl_synop_normal(partBaseline),
      colors.map.synop.availability[1],
      cl_synop_moreThan100p(partBaseline),
      colors.map.synop.availability[0],
      cl_synop_expectedZero(partBaseline),
      colors.map.synop.availability[5],
      /* other - never used here but needed */ colors.map.classNeeded
    ];
  } else {
    return [
      "case",
      cl_synop_not_in_oscar,
      colors.map.synop.availability[6],
      cl_synop_in_oscar,
      [
        "case",
        cl_synop_silent,
        colors.map.synop.availability[4],
        cl_synop_big_issues(partBaseline),
        colors.map.synop.availability[3],
        cl_synop_small_issues(partBaseline),
        colors.map.synop.availability[2],
        cl_synop_normal(partBaseline),
        colors.map.synop.availability[1],
        cl_synop_moreThan100p(partBaseline),
        colors.map.synop.availability[0],
        cl_synop_expectedZero(partBaseline),
        colors.map.synop.availability[5],
        /* other - never used here but needed */ colors.map.classNeeded
      ],
      // below is never used here but needed
      colors.map.classNeeded
    ];
  }
};

export const getStyleMarineAvailability = (baseline, period_type, date) => {
  let valuePeriodType = 6; // for six_hour
  if (period_type === "daily") {
    valuePeriodType = 24;
  } else if (period_type === "monthly") {
    let nbDays = getDaysInMonth(date);
    valuePeriodType = ["*", nbDays, 24];
  }
  const partBaseline =
    baseline === "OSCAR" ? ["get", "nr_expected"] : valuePeriodType;
  return [
    "case",
    cl_synop_not_in_oscar,
    colors.map.synop.availability[6],
    cl_synop_in_oscar,
    [
      "case",
      cl_synop_silent,
      colors.map.synop.availability[4],
      cl_synop_big_issues(partBaseline),
      colors.map.synop.availability[3],
      cl_synop_small_issues(partBaseline),
      colors.map.synop.availability[2],
      cl_synop_normal(partBaseline),
      colors.map.synop.availability[1],
      cl_synop_moreThan100p(partBaseline),
      colors.map.synop.availability[1],
      cl_synop_expectedZero(partBaseline),
      colors.map.synop.availability[5],
      /* other - never used here but needed */ colors.map.classNeeded
    ],
    colors.map.classNeeded
  ];
};

export const getStyleGbonSynopAvailability = (baseline, period_type) => {
  let valuePeriodType = 6;
  if (period_type === "daily") {
    valuePeriodType = 24;
  } else {
    // monthly
    valuePeriodType = ["get", "nr_expected"];
  }
  const partBaseline = valuePeriodType;

  return [
    "case",
    cl_synop_not_in_oscar,
    colors.map.synop.availability[6],
    cl_synop_in_oscar,
    [
      "case",
      cl_synop_silent,
      colors.map.synop.availability[4],
      cl_gbon_synop_big_issues(partBaseline),
      colors.map.synop.availability[3],
      cl_gbon_synop_small_issues(partBaseline),
      colors.map.synop.availability[2],
      cl_gbon_synop_normal(partBaseline),
      colors.map.synop.availability[1],
      cl_gbon_synop_expectedZero(partBaseline),
      colors.map.synop.availability[5],
      /* other - never used here but needed */ colors.map.classNeeded
    ],
    // below is never used here but needed
    colors.map.classNeeded
  ];
};

export const getStyleWis2vsGts = (report, baseline, period_type) => {
  if (report === "gts-to-wis2") {
    return [
      "case",
      // GTS only (nr_received_gts > 0 and nr_received_wis2 is null or 0)
      [
        "all",
        [">", ["get", "nr_received_gts"], 0],
        ["==", ["get", "nr_received_wis2"], 0]
      ],
      "#8B0000", // brown for GTS only

      // WIS2 only (nr_received_wis2 > 0 and nr_received_gts is null or 0)
      [
        "all",
        [">", ["get", "nr_received_wis2"], 0],
        ["==", ["get", "nr_received_gts"], 0]
      ],
      "rgb(0, 153, 0)", // Green for WIS2 only
      "#0000FF" // blue for WIS2 and GTS
    ];
  } else if (report === "tac-to-bufr") {
    return [
      "case",
      // Both BUFR and TAC reporting
      [
        "all",
        [">", ["get", "bufr_nr_received"], 0],
        [">", ["get", "tac_nr_received"], 0]
      ],

      "#0000FF", // Blue for BUFR only
      // BUFR only reporting
      [
        "all",
        [">", ["get", "bufr_nr_received"], 0],
        ["==", ["get", "tac_nr_received"], 0]
      ],
      "#00AA00", // Green for Both

      // TAC only reporting
      [
        "all",
        [">", ["get", "tac_nr_received"], 0],
        ["==", ["get", "bufr_nr_received"], 0]
      ],
      "#8B0000", // Purple for TAC only

      // Default case - no reporting
      "#CCCCCC" // Grey
    ];
  } else if (report === "bufr_oscar_coords") {
    return [
      "case",
      // Distance difference 1-10 meters - Light red
      [
        "all",
        ["<=", ["get", "distance_diff"], 10],
        [">", ["get", "distance_diff"], 0]
      ],
      "#FFCDD2", // Very light red for small differences

      // Distance difference >10 to 1000 meters - Medium red
      [
        "all",
        ["<=", ["get", "distance_diff"], 1000],
        [">", ["get", "distance_diff"], 10]
      ],
      "#E57373", // Medium red for moderate differences

      // Distance difference >= 1000 meters - Dark red
      "#C62828" // Dark red for large differences
    ];
  }
};

export const getStyleGSynopTimeliness = (baseline, period_type) => {
  const partBaseline = 2591;

  return [
    "case",
    cl_very_small_timeliness_delay(partBaseline),
    colors.map.synop.timeliness[0],
    cl_small_timeliness_delay(partBaseline),
    colors.map.synop.timeliness[1], // red
    cl_moderate_timeliness_delay(partBaseline),
    colors.map.synop.timeliness[2], // green
    cl_large_timeliness_delay(partBaseline),
    colors.map.synop.timeliness[3],
    /* other - never used here but needed */ colors.map.synop.timeliness[3]
  ];
};
// Quality

const cl_synop_le_0p02 = ["<=", ["get", "avg_bg_dep"], 0.02];

const cl_synop_le_0p5 = ["<=", ["get", "avg_bg_dep"], 0.5];

const cl_synop_le_30 = ["<=", ["get", "avg_bg_dep"], 30];

const cl_synop_gt_0p02_le_0p05 = [
  "all",
  [">", ["get", "avg_bg_dep"], 0.02],
  ["<=", ["get", "avg_bg_dep"], 0.05]
];

const cl_synop_gt_0p05_le_0p1 = [
  "all",
  [">", ["get", "avg_bg_dep"], 0.05],
  ["<=", ["get", "avg_bg_dep"], 0.1]
];

const cl_synop_gt_0p1_le_0p15 = [
  "all",
  [">", ["get", "avg_bg_dep"], 0.1],
  ["<=", ["get", "avg_bg_dep"], 0.15]
];

const cl_synop_gt_0p15_le_0p3 = [
  "all",
  [">", ["get", "avg_bg_dep"], 0.15],
  ["<=", ["get", "avg_bg_dep"], 0.3]
];

const cl_synop_gt_0p5_le_1 = [
  "all",
  [">", ["get", "avg_bg_dep"], 0.5],
  ["<=", ["get", "avg_bg_dep"], 1]
];

const cl_synop_gt_0p5_le_2 = [
  "all",
  [">", ["get", "avg_bg_dep"], 0.5],
  ["<=", ["get", "avg_bg_dep"], 2]
];

const cl_synop_gt_1_le_2 = [
  "all",
  [">", ["get", "avg_bg_dep"], 1],
  ["<=", ["get", "avg_bg_dep"], 2]
];

const cl_synop_gt_1_le_5 = [
  "all",
  [">", ["get", "avg_bg_dep"], 1],
  ["<=", ["get", "avg_bg_dep"], 5]
];
const cl_synop_gt_2_le_3 = [
  "all",
  [">", ["get", "avg_bg_dep"], 2],
  ["<=", ["get", "avg_bg_dep"], 3]
];

const cl_synop_gt_2_le_5 = [
  "all",
  [">", ["get", "avg_bg_dep"], 2],
  ["<=", ["get", "avg_bg_dep"], 5]
];

const cl_synop_gt_3_le_5 = [
  "all",
  [">", ["get", "avg_bg_dep"], 3],
  ["<=", ["get", "avg_bg_dep"], 5]
];

const cl_synop_gt_5_le_10 = [
  "all",
  [">", ["get", "avg_bg_dep"], 5],
  ["<=", ["get", "avg_bg_dep"], 10]
];

const cl_synop_gt_5_le_15 = [
  "all",
  [">", ["get", "avg_bg_dep"], 5],
  ["<=", ["get", "avg_bg_dep"], 15]
];

const cl_synop_gt_30_le_40 = [
  "all",
  [">", ["get", "avg_bg_dep"], 30],
  ["<=", ["get", "avg_bg_dep"], 40]
];
const cl_synop_gt_40_le_100 = [
  "all",
  [">", ["get", "avg_bg_dep"], 40],
  ["<=", ["get", "avg_bg_dep"], 100]
];

const cl_synop_gt_0p3 = [">", ["get", "avg_bg_dep"], 0.3];

const cl_synop_gt_10 = [">", ["get", "avg_bg_dep"], 10];

const cl_synop_gt_15 = [">", ["get", "avg_bg_dep"], 15];

const cl_synop_gt_100 = [">", ["get", "avg_bg_dep"], 100];

export const getStyleSynopQuality = varid => {
  let style;
  if (varid === "110") {
    style = [
      "case",
      cl_synop_le_0p5,
      colors.map.synop.quality[0],
      cl_synop_gt_0p5_le_1,
      colors.map.synop.quality[1],
      cl_synop_gt_1_le_5,
      colors.map.synop.quality[3],
      cl_synop_gt_5_le_10,
      colors.map.synop.quality[4],
      cl_synop_gt_10,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else if (varid === "39") {
    style = [
      "case",
      cl_synop_le_0p5,
      colors.map.synop.quality[0],
      cl_synop_gt_0p5_le_1,
      colors.map.synop.quality[1],
      cl_synop_gt_1_le_2,
      colors.map.synop.quality[2],
      cl_synop_gt_2_le_5,
      colors.map.synop.quality[3],
      cl_synop_gt_5_le_10,
      colors.map.synop.quality[4],
      cl_synop_gt_10,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else if (varid === "41" || varid === "42") {
    style = [
      "case",
      cl_synop_le_0p5,
      colors.map.synop.quality[0],
      cl_synop_gt_0p5_le_2,
      colors.map.synop.quality[1],
      cl_synop_gt_2_le_3,
      colors.map.synop.quality[2],
      cl_synop_gt_3_le_5,
      colors.map.synop.quality[3],
      cl_synop_gt_5_le_15,
      colors.map.synop.quality[4],
      cl_synop_gt_15,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else if (varid === "58") {
    style = [
      "case",
      cl_synop_le_0p02,
      colors.map.synop.quality[0],
      cl_synop_gt_0p02_le_0p05,
      colors.map.synop.quality[1],
      cl_synop_gt_0p05_le_0p1,
      colors.map.synop.quality[2],
      cl_synop_gt_0p1_le_0p15,
      colors.map.synop.quality[3],
      cl_synop_gt_0p15_le_0p3,
      colors.map.synop.quality[4],
      cl_synop_gt_0p3,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else {
    // Geopotential (varid = 1)
    style = [
      "case",
      cl_synop_le_30,
      colors.map.synop.quality[0],
      cl_synop_gt_30_le_40,
      colors.map.synop.quality[3],
      cl_synop_gt_40_le_100,
      colors.map.synop.quality[4],
      cl_synop_gt_100,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  }
  return style;
};

const cl_synop_monthly_le_0p02 = ["<=", ["get", "rms"], 0.02];

const cl_synop_monthly_le_0p5 = ["<=", ["get", "rms"], 0.5];

const cl_synop_monthly_le_30 = ["<=", ["get", "rms"], 30];

const cl_synop_monthly_gt_0p02_le_0p05 = [
  "all",
  [">", ["get", "rms"], 0.02],
  ["<=", ["get", "rms"], 0.05]
];

const cl_synop_monthly_gt_0p05_le_0p1 = [
  "all",
  [">", ["get", "rms"], 0.05],
  ["<=", ["get", "rms"], 0.1]
];

const cl_synop_monthly_gt_0p1_le_0p15 = [
  "all",
  [">", ["get", "rms"], 0.1],
  ["<=", ["get", "rms"], 0.15]
];

const cl_synop_monthly_gt_0p15_le_0p3 = [
  "all",
  [">", ["get", "rms"], 0.15],
  ["<=", ["get", "rms"], 0.3]
];

const cl_synop_monthly_gt_0p5_le_1 = [
  "all",
  [">", ["get", "rms"], 0.5],
  ["<=", ["get", "rms"], 1]
];

const cl_synop_monthly_gt_0p5_le_2 = [
  "all",
  [">", ["get", "rms"], 0.5],
  ["<=", ["get", "rms"], 2]
];

const cl_synop_monthly_gt_1_le_2 = [
  "all",
  [">", ["get", "rms"], 1],
  ["<=", ["get", "rms"], 2]
];

const cl_synop_monthly_gt_1_le_5 = [
  "all",
  [">", ["get", "rms"], 1],
  ["<=", ["get", "rms"], 5]
];
const cl_synop_monthly_gt_2_le_3 = [
  "all",
  [">", ["get", "rms"], 2],
  ["<=", ["get", "rms"], 3]
];

const cl_synop_monthly_gt_2_le_5 = [
  "all",
  [">", ["get", "rms"], 2],
  ["<=", ["get", "rms"], 5]
];

const cl_synop_monthly_gt_3_le_5 = [
  "all",
  [">", ["get", "rms"], 3],
  ["<=", ["get", "rms"], 5]
];

const cl_synop_monthly_gt_5_le_10 = [
  "all",
  [">", ["get", "rms"], 5],
  ["<=", ["get", "rms"], 10]
];

const cl_synop_monthly_gt_5_le_15 = [
  "all",
  [">", ["get", "rms"], 5],
  ["<=", ["get", "rms"], 15]
];

const cl_synop_monthly_gt_30_le_40 = [
  "all",
  [">", ["get", "rms"], 30],
  ["<=", ["get", "rms"], 40]
];
const cl_synop_monthly_gt_40_le_100 = [
  "all",
  [">", ["get", "rms"], 40],
  ["<=", ["get", "rms"], 100]
];

const cl_synop_monthly_gt_0p3 = [">", ["get", "rms"], 0.3];

const cl_synop_monthly_gt_10 = [">", ["get", "rms"], 10];

const cl_synop_monthly_gt_15 = [">", ["get", "rms"], 15];

const cl_synop_monthly_gt_100 = [">", ["get", "rms"], 100];
export const getStyleSynopMonthlyQuality = varid => {
  let style;
  if (varid === "110") {
    style = [
      "case",
      cl_synop_monthly_le_0p5,
      colors.map.synop.quality[0],
      cl_synop_monthly_gt_0p5_le_1,
      colors.map.synop.quality[1],
      cl_synop_monthly_gt_1_le_5,
      colors.map.synop.quality[3],
      cl_synop_monthly_gt_5_le_10,
      colors.map.synop.quality[4],
      cl_synop_monthly_gt_10,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else if (varid === "39") {
    style = [
      "case",
      cl_synop_monthly_le_0p5,
      colors.map.synop.quality[0],
      cl_synop_monthly_gt_0p5_le_1,
      colors.map.synop.quality[1],
      cl_synop_monthly_gt_1_le_2,
      colors.map.synop.quality[2],
      cl_synop_monthly_gt_2_le_5,
      colors.map.synop.quality[3],
      cl_synop_monthly_gt_5_le_10,
      colors.map.synop.quality[4],
      cl_synop_monthly_gt_10,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else if (varid === "41" || varid === "42") {
    style = [
      "case",
      cl_synop_monthly_le_0p5,
      colors.map.synop.quality[0],
      cl_synop_monthly_gt_0p5_le_2,
      colors.map.synop.quality[1],
      cl_synop_monthly_gt_2_le_3,
      colors.map.synop.quality[2],
      cl_synop_monthly_gt_3_le_5,
      colors.map.synop.quality[3],
      cl_synop_monthly_gt_5_le_15,
      colors.map.synop.quality[4],
      cl_synop_monthly_gt_15,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else if (varid === "58") {
    style = [
      "case",
      cl_synop_monthly_le_0p02,
      colors.map.synop.quality[0],
      cl_synop_monthly_gt_0p02_le_0p05,
      colors.map.synop.quality[1],
      cl_synop_monthly_gt_0p05_le_0p1,
      colors.map.synop.quality[2],
      cl_synop_monthly_gt_0p1_le_0p15,
      colors.map.synop.quality[3],
      cl_synop_monthly_gt_0p15_le_0p3,
      colors.map.synop.quality[4],
      cl_synop_monthly_gt_0p3,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  } else {
    // Geopotential (varid = 1)
    style = [
      "case",
      cl_synop_monthly_le_30,
      colors.map.synop.quality[0],
      cl_synop_monthly_gt_30_le_40,
      colors.map.synop.quality[3],
      cl_synop_monthly_gt_40_le_100,
      colors.map.synop.quality[4],
      cl_synop_monthly_gt_100,
      colors.map.synop.quality[5],
      // never used but needed
      colors.map.classNeeded
    ];
  }
  return style;
};
